const LOCAL_TIME_STAGE: any = {
    us: {
        teaser: '2023/10/02 20:30:00 GMT+8',
        prelaunch: '2023/11/01 20:30:00 GMT+8',
        launch: '2024/01/09 21:30:00 GMT+8',
    },
    jp: {
        teaser: '2023/10/14 17:00:00 GMT+8',
        prelaunch: '2023/12/27 10:00:00',
        launch: '2024/01/12 21:30:00 GMT+8',
    },
};

export const getLocalTimeStage = (locale: string, type: string) =>
    LOCAL_TIME_STAGE[locale] ? LOCAL_TIME_STAGE[locale][type] || 0 : LOCAL_TIME_STAGE['us'][type] || 0;
